import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Scissors, ArrowUpRight } from "lucide-react";
import { IMAGES } from "../data/content";
import { useT } from "../i18n/LanguageContext";

export default function FriseurPromo() {
  const { t } = useT();
  return (
    <section
      data-testid="friseur-promo"
      className="relative py-24 sm:py-32 bg-[#050505] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="relative grid grid-cols-1 lg:grid-cols-12 gap-0 border border-[#D4AF37]/30 overflow-hidden group"
        >
          <div className="relative lg:col-span-6 min-h-[280px] lg:min-h-[460px] overflow-hidden">
            <img
              src={IMAGES.interior}
              alt="Friseur Studio"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-black/20 to-black lg:to-[#050505]" />
            <div className="absolute top-6 left-6 flex items-center gap-2 text-[10px] tracking-[0.32em] uppercase text-[#D4AF37]">
              <Scissors size={14} strokeWidth={1.5} />
              <span>{t("friseur_promo.badge")}</span>
            </div>
          </div>

          <div className="lg:col-span-6 p-8 sm:p-12 lg:p-16 flex flex-col justify-center bg-[#0a0a0a]">
            <span className="overline">{t("friseur_promo.overline")}</span>
            <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05] font-light">
              {t("friseur_promo.title_1")}{" "}
              <em className="shimmer-gold not-italic">{t("friseur_promo.title_em")}</em>
            </h2>
            <p className="mt-6 text-white/65 text-base sm:text-lg font-light leading-relaxed max-w-md">
              {t("friseur_promo.description")}
              <span className="block mt-2 text-white/45 text-sm">{t("friseur_promo.phone_note")}</span>
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Link to="/friseur" data-testid="friseur-promo-cta" className="btn-gold group">
                {t("friseur_promo.cta")}
                <ArrowUpRight
                  size={16}
                  strokeWidth={1.5}
                  className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                />
              </Link>
            </div>

            <div className="mt-10 pt-8 border-t border-white/10 grid grid-cols-3 gap-4 text-[11px] tracking-[0.22em] uppercase text-white/55">
              <div><span className="text-[#D4AF37]">01</span><p className="mt-1">{t("friseur_promo.col_1")}</p></div>
              <div><span className="text-[#D4AF37]">02</span><p className="mt-1">{t("friseur_promo.col_2")}</p></div>
              <div><span className="text-[#D4AF37]">03</span><p className="mt-1">{t("friseur_promo.col_3")}</p></div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
